import r from "./_nativeCreate.js";
var e = r, o = Object.prototype, n = o.hasOwnProperty;
function s(a) {
  var t = this.__data__;
  return e ? t[a] !== void 0 : n.call(t, a);
}
var v = s;
export {
  v as default
};
//# sourceMappingURL=_hashHas.js.map
